import { compare as fjpCompare } from "fast-json-patch";
import cloneDeep from "lodash/cloneDeep";
/**
 * 
 * @param {Array} current new attributes array to format for payload
 * @param {Array} existingAttributes current attributes in cache
 * @returns { createdItems, editedItems, deletedItemIds } = props for corresponding API request
 * @example
 * Create
  if (createdItems?.length) {
    const props = { args: { createdItems } };
    await createAttributes(props);
  }
  Patch
  if (editedItems?.length) {
    const props = { args: { editedItems } };
    await editAttributes(props);
  }
  Delete
  if (deletedItemsIds?.length) {
    const props = { args: { deletedItemsIds } };
    await deleteAttributes(props);
  }
 */
const formatAttributesPayload = async (current, existingAttributes) => {
  const createdItems = [];
  const deletedItemsIds = [];
  const copyOfCurrent = cloneDeep(current);
  const copyOfExisting = cloneDeep(existingAttributes);

  const currentAttributes = copyOfCurrent?.map((item) => {
    if (item?.options?.length) {
      return {
        ...item,
        options: item?.options?.map(({ label, value }) => ({
          id: value,
          name: label,
        })),
      };
    }
    if (item?.unit?.options?.length) {
      return {
        ...item,
        fieldType: "number-entry",
        unit: {
          ...item?.unit,
          options: item.unit.options.map(({ label, value }) => ({
            id: value,
            name: label,
          })),
        },
      };
    }
    return item;
  });

  const currentAttributesMap = currentAttributes.reduce(
    (a, v) => ({ ...a, [`${v.id}`]: v }),
    {}
  );
  const existingAttributesMap = copyOfExisting.reduce(
    (a, v) => ({ ...a, [`${v.id}`]: v }),
    {}
  );
  // Delete Items
  copyOfExisting?.forEach((old) => {
    if (!currentAttributesMap[old.id]) {
      deletedItemsIds.push(old.id);
    }
  });

  // POST Items
  const itemsToPost = currentAttributes?.filter(
    (attribute) => attribute?.wasAdded
  );
  if (itemsToPost?.length > 0) {
    itemsToPost?.forEach((item) => {
      const updated = cloneDeep(item);
      delete updated?.wasAdded;
      createdItems?.push(updated);
    });
  }

  // Patch Items

  const editedItems = currentAttributes
    ?.filter((attribute) => attribute.wasUpdated && !attribute.wasAdded)
    ?.map((attribute) => {
      const { wasUpdated, ...rest } = attribute;

      return {
        id: rest.id,
        metadata: {
          lastUpdated: rest?.metadata?.lastUpdated,
        },
        patch: fjpCompare(existingAttributesMap[rest.id], rest),
      };
    });

  return {
    createdItems,
    editedItems,
    deletedItemsIds,
  };
};

export default formatAttributesPayload;
